 
$(function(){
	//Globals
  	let isFiltered = false;
  
// Slider Next/prev Buttons
  const btnPrevious = $('.variant-slider .slider-prev');
  const btnNext = $('.variant-slider .slider-next');
  
  btnNext.click((e) => {
    next();     
  	e.preventDefault();	
  });
  
  btnPrevious.click((e) => {
    previous();     
  	e.preventDefault();	
  });  
  
  
// Variants image slider
  const container = $('.variant-slider-container');
  const items = $('.variant-slider-item');
  
  let offset = 0;
  
  function next(){
    let x = offset - getOffsetValue()*2;
    if(x < getMinOffset()) x = getMinOffset();    
    
    
  	transalteSlider(x);
  }
  
  function previous(){
    let x = offset + getOffsetValue()*2;
    if(x > 0 ) x = 0;

    transalteSlider(x);
  }
  
 	 // Set the offset for show the current variant image
  function SetCurrentVariantOffset(){
    let cvOffset = 0;
    let ItemWidth = 100;
    
    $(items).each((i, item) => {
      
      if($(item).hasClass('hide')) return true;
      
      if($(item).hasClass('active')) return false; 
      
      cvOffset -= ItemWidth;      	       
      
    });
    
    if($(items).hasClass('hide')) cvOffset = 0;
    if(isFiltered) return;
    
    transalteSlider(cvOffset);
  }
      
  function transalteSlider(x){
  	$(container).css('transform', 'translate('+ x +'px, 0)');
    offset = x;
  }
      
  function getMinOffset(){
    let px = 0;
    
    items.each((i, item) => {
      if(!$(item).hasClass('hide')){
      	px += $(item).width();
      }
	});
    
    
    return px*-1;
  }
  
  // Get the width of a individual slider item
  function getOffsetValue(){
  	return $(items).outerWidth();    
  }
  
  function getContainerWidth(){
  	return container_width = $('.variant-slider-container').width();
  }
  
  
  
  
  
// Auto select current variant
  $('.variant-slider-item').click((e) => {          
    
    const alt = $(e.target).find('img').attr('alt');	
    const variantID = alt.trim();  
  
    const variant = getVariantOptions(variantID);
    
	const option1 = variant[0];
    const option2 = variant[1];
    const option3 = variant[2];

    
    if(option1){
      const option = $('.option-value-input[data-product-option="option1"][value="' + option1 + '"]');
      option.click();
    }

    if(option2){
      const option = $('.option-value-input[data-product-option="option2"][value="' + option2 + '"]');
      option.click();
    }

    if(option3){
      const option = $('.option-value-input[data-product-option="option3"][value="' + option3 + '"]');
      option.click();
    }
  	
		
  });
  
  function getVariantOptions(variantID){
     const variants = $('.product-form-grid select[name="id"] option[value="'+variantID+'"]');
    
     const options = [
       $(variants).data('option1'),
       $(variants).data('option2'),
       $(variants).data('option3')
     ];
    
    return options;     
  }
       
  
// Auto select image On load  	
  
  const variantOP1 = $('form[action="/cart/add"] .option-value-input[data-product-option="option1"]:checked').attr('value');
  const variantOP2 = $('form[action="/cart/add"] .option-value-input[data-product-option="option2"]:checked').attr('value');
  const variantOP3 = $('form[action="/cart/add"] .option-value-input[data-product-option="option3"]:checked').attr('value');
  
  let variantOPS = variantOP1 + (variantOP2 ? '_'+variantOP2 : "") + (variantOP3 ? '_'+variantOP3 : "");
  
	const SelectImageVariant = (() => {
  		$('.variant-slider-item[data-alt="' + variantOPS + '"]').click();
    })

    setTimeout(SelectImageVariant, 1000);
  

  
  
  
  
 
  
  
// Hide Images that haven't the current "main" variant option 
// the main option will be the "Color" unless the product has 1 variant option only
  
  
  const defaultMain = "Color";

  
  const {mainOption, mainIndex} = getMainOption(defaultMain);
  console.log(mainOption, mainIndex);

  
  if(mainOption && mainIndex !== -1){
  	const MainOptions = $('input.option-value-input[name="' + mainOption + '"]');
    
    $(MainOptions).change((e) => {
      if(($(e.target).prop('checked')) === false) return;
      
      	let value = $(e.target).attr('value');
		filterByVariantOption(mainIndex, value);
//       setTimeout(() => {SetCurrentVariantOffset()}, 500);
    });
  
    const restOptions = $('input.option-value-input').not(MainOptions);
    restOptions.change((e) => {
      	if(($(e.target).prop('checked')) === false) return;

    	setTimeout(() => {SetCurrentVariantOffset()}, 500);
    });
  }
  else{
  	const allOptions = $('input.option-value-input');
	allOptions.change((e) => {
      	if(($(e.target).prop('checked')) === false) return;
      
		setTimeout(() => {SetCurrentVariantOffset()}, 500);
    });
  }
  
  $('input.option-value-input').click((e) => {
		
  });
  
  
  let currentValue = null;
  function filterByVariantOption(variantIndex, value){
    
    const options = $('.product-form-grid select[name="id"] option[data-option'+(variantIndex+1)+'="'+value+'"]');
    
    let variantIDs = [];
    
    options.each(function(i, elm){
      variantIDs.push($(elm).attr('value'));
    });
    
    
    
  	const items = $('.variant-slider-item');
    
	let foundColor = false;
    items.each((i, item) => {
		let alt = $(item).find('img').attr('alt');
      	let variantID = alt.trim();    
      
		
      	
        if(variantIDs.includes(variantID)){
			$(item).toggleClass('hide', false);
          	foundColor = true;
        }
        else{
			$(item).toggleClass('hide', true);
        }

      
    });
    
    if(!foundColor){
      $(items).toggleClass('hide', false);
      isFiltered = false;
    }
    else{
    	isFiltered = true;
    }
    
    
    if(currentValue !== value){
    	transalteSlider(0);
    }
    else{
   	  	// Set/Reset slider Offset
		setTimeout(() => {SetCurrentVariantOffset()}, 500);
    }

	currentValue = value;           

  }
  
  function getMainOption(defaultMain){
  	
    let options = [];
    let mainOption;
  	let mainIndex = -1;
    
    const option_divs = $('.product-form-grid .option-values');

    option_divs.each((i, option) => { 
      const optionName = $(option).find('input.option-value-input').attr('name');
      options.push(optionName);
    });

    if(options.length === 1){
      mainOption = options[0];
      mainIndex = 0;
    }
    else if(options.length > 1){
      let indexDefault = options.findIndex((elm) => elm === defaultMain);
      if(indexDefault !== -1){
          mainOption = options[indexDefault];
          mainIndex = indexDefault;
      }
    }
    
    return {
      mainOption,
      mainIndex
    }
  
  }
  
  
  
});
  

